import { useState, useEffect } from 'react';
import { AgxLabel, AgxRadio } from '@urbanx/agx-ui-components';
import FlatCommission from '../FlatCommission/FlatCommission';
import { AdjustmentCommissionType, AdjustmentToCommission } from './types';
import './AdjustmentCommission.scss';

interface AdjustmentCommissionProps {
  id: string;
  label?: string;
  onValueChanged: (value: {
    id: string;
    value: AdjustmentToCommission;
  }) => void;
  defaultValue: AdjustmentToCommission;
  validate?: boolean;
  required?: boolean;
}

const AdjustmentCommissionComponent = ({
  id,
  label,
  defaultValue,
  onValueChanged,
  validate,
  required,
}: AdjustmentCommissionProps) => {
  const [adjustmentCommissionState, setAdjustmentCommissionState] =
    useState<AdjustmentToCommission>({
      condition:
        defaultValue?.condition ?? AdjustmentCommissionType.NoAdjustment,
      adjustedCommissionRate: defaultValue?.adjustedCommissionRate,
    });

  const { condition, adjustedCommissionRate } = adjustmentCommissionState;

  useEffect(() => {
    onValueChanged({ id, value: { ...adjustmentCommissionState } });
  }, [adjustmentCommissionState]);

  return (
    <div className="agxRadio">
      <AgxLabel medium>{label}</AgxLabel>
      <div className="agxRadio-group">
        <AgxRadio
          id="noAdjustment"
          label="No adjustment"
          onCheckChanged={() =>
            setAdjustmentCommissionState({
              ...adjustmentCommissionState,
              condition: AdjustmentCommissionType.NoAdjustment,
            })
          }
          checked={condition === AdjustmentCommissionType.NoAdjustment}
        />
        <AgxRadio
          id="yesAdjustment"
          label="Yes"
          onCheckChanged={() =>
            setAdjustmentCommissionState({
              ...adjustmentCommissionState,
              condition: AdjustmentCommissionType.YesAdjustment,
            })
          }
          checked={condition === AdjustmentCommissionType.YesAdjustment}
          subContent={
            condition === AdjustmentCommissionType.YesAdjustment
              ? [
                  <FlatCommission
                    id="adjustedCommissionRate"
                    key="adjustedCommissionRate"
                    onValueChanged={({ value }) =>
                      setAdjustmentCommissionState({
                        ...adjustmentCommissionState,
                        adjustedCommissionRate: value,
                      })
                    }
                    defaultValue={adjustedCommissionRate}
                    validate={validate}
                    required={true}
                    small={true}
                  />,
                ]
              : undefined
          }
        />
      </div>
    </div>
  );
};

export default AdjustmentCommissionComponent;
